import { createPortal } from 'react-dom';
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  DeleteButton,
  CancelButton,
  MessageText
} from './DeleteCardTypeCategoryModal.styles';

export default function DeleteCardTypeCategoryModal({ 
  isOpen, 
  onClose,
  category,
  cardCount,
  onConfirmDelete
}) {
  const handleDelete = async () => {
    if (onConfirmDelete) {
      await onConfirmDelete(category);
    }
    onClose();
  };

  if (!isOpen) return null;

  const modalContent = (
    <ModalOverlay onClick={onClose} className='widget-bg'>
      <ModalContainer onClick={(e) => e.stopPropagation()} className='panel-bg'>
        <ModalHeader>
          <ModalTitle>Delete Category</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>

        <ModalBody>
          <MessageText>
            {cardCount} {cardCount === 1 ? 'card' : 'cards'} will be deleted if you delete this card type category. This cannot be undone.
          </MessageText>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <DeleteButton onClick={handleDelete}>
              Delete
            </DeleteButton>
            <CancelButton onClick={onClose}>
              Cancel
            </CancelButton>
          </ButtonGroup>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>
  );

  return createPortal(modalContent, document.body);
}

